import {
    NEWCONTROL,SHOW_LOADING,UPDATECONTROL
} from "../constants/AppControls";
import {
    AUTH_TOKEN, HIDE_AUTH_MESSAGE, SHOW_AUTH_MESSAGE
} from "../constants/Auth";

const initState = {
    loading: false,
    message: '',
    showMessage: false,
    redirect: '',
    token: localStorage.getItem(AUTH_TOKEN),
}

const appControls = (state = initState, action) => {
    switch (action.type) {
        case NEWCONTROL:
            return {
                ...state,
                loading: false,
                message: action.message,
                showMessage: true,
            }
        case SHOW_AUTH_MESSAGE:
            return {
                ...state,
                message: action.message,
                showMessage: true,
                loading: false
            }
        case UPDATECONTROL:
            return {
                ...state,
                message: action.message,
                showMessage: true,
                loading: false,
            }
        case HIDE_AUTH_MESSAGE:
            return {
                ...state,
                message: '',
                showMessage: false,
            }
        case SHOW_LOADING: {
            return {
                ...state,
                loading: true
            }
        }
        default:
            return state;
    }
}

export default appControls